export const SET_OFFERS_CONTENT = 'SET_OFFERS_CONTENT';
